<template>
    <grid-area
        area="left"
        scroll
    >
        <flex-container :padding="Size.md">
            <flex-container>
                <flex-container :size="6">
                    <contact-card-tabs-skeleton>
                        <contact-card-tabs
                            :contact-id="props.lead.primaryContact.id"
                            :editable="isUserOfAssignedCompany"
                        />
                    </contact-card-tabs-skeleton>
                </flex-container>

                <flex-container :size="4" style="padding-top: 40px;">
                    <lead-state-card-skeleton>
                        <lead-state-card
                            :lead="props.lead"
                        />
                    </lead-state-card-skeleton>
                    <lead-score-card-skeleton>
                        <lead-score-card
                            :lead="props.lead"
                        />
                    </lead-score-card-skeleton>
                </flex-container>
            </flex-container>

            <lead-progress-card-skeleton>
                <lead-progress-card :lead="props.lead" />
            </lead-progress-card-skeleton>

            <woon-objecten-card-skeleton>
                <woon-objecten-card :contact-id="props.lead.primaryContact.id" :lead-id="props.lead.id" />
            </woon-objecten-card-skeleton>

            <flex-container>
                <flex-container :size="5">
                    <user-team-card-skeleton>
                        <lead-referrer-card :lead="props.lead" />
                        <template #title>
                            Aanmaker
                        </template>
                    </user-team-card-skeleton>
                </flex-container>

                <flex-container :size="5">
                    <user-team-card-skeleton>
                        <lead-assignee-card :lead="props.lead" />
                        <template #title>
                            Verantwoordelijk
                        </template>
                    </user-team-card-skeleton>
                </flex-container>
            </flex-container>

            <lead-card-tabs-skeleton>
                <lead-card-tabs :lead="props.lead" />
            </lead-card-tabs-skeleton>

            <!-- done because the date dropdown of financial tab will overflow -->
            <div style="height: 150px; width: 100%;" />
        </flex-container>
    </grid-area>
</template>

<script lang="ts" setup>
    import { FlexContainer, GridArea, Size } from '@keyvue/one-ui';
    import ContactCardTabs from '@components/Cards/ContactCardTabs.vue';
    import type { Lead } from '@keyvue/one-api-client';
    import LeadCardTabs from '@components/Cards/Lead/LeadCardTabs.vue';
    import LeadAssigneeCard from '@components/Cards/Lead/LeadAssigneeCard.vue';
    import LeadReferrerCard from '@components/Cards/Lead/LeadReferrerCard.vue';
    import LeadProgressCard from '@components/Cards/Lead/LeadProgressCard.vue';
    import LeadStateCard from '@components/Cards/Lead/LeadStateCard.vue';
    import LeadScoreCard from '@components/Cards/Lead/LeadScoreCard.vue';
    import useLeadSecurity from '@composables/security/useLeadSecurity';
    import LeadStateCardSkeleton from '@components/Skeleton/Cards/Lead/LeadStateCardSkeleton.vue';
    import LeadScoreCardSkeleton from '@components/Skeleton/Cards/Lead/LeadScoreCardSkeleton.vue';
    import ContactCardTabsSkeleton from '@components/Skeleton/Cards/ContactCardTabsSkeleton.vue';
    import UserTeamCardSkeleton from '@components/Skeleton/Cards/UserTeamCardSkeleton.vue';
    import LeadCardTabsSkeleton from '@components/Skeleton/Cards/Lead/LeadCardTabsSkeleton.vue';
    import LeadProgressCardSkeleton from '@components/Skeleton/Cards/Lead/LeadProgressCardSkeleton.vue';
    import WoonObjectenCard from '@/realworks/components/card/WoonObjectenCard.vue';
    import WoonObjectenCardSkeleton from '@/realworks/components/skeleton/WoonObjectenCardSkeleton.vue';

    interface Props {
        lead: Lead;
    }

    const props = defineProps<Props>();
    const { isUserOfAssignedCompany } = await useLeadSecurity(props.lead);
</script>
